import React from 'react';
import Collapse from '@mui/material/Collapse';
import ListItem from '@mui/material/ListItem';
import ListItemText from '@mui/material/ListItemText';
import Icon from '@mui/material/Icon';
import { MDBox } from '../../MDBox';
import { item, itemContent, itemArrow } from './styles/sidenavItem';
import { useMaterialUIController } from '../../../contexts/layoutContext';
import { FFTheme } from '../../../assets/theme';
import { ListItemIcon, useTheme } from '@mui/material';
import { collapseIconBox } from './styles/sidenavCollapse';
import { MDTypography } from 'components/MDTypography';
import { sidebar } from '../../../assets/theme/tokens';

interface SidenavItemProps {
  color?:
    | 'primary'
    | 'secondary'
    | 'info'
    | 'success'
    | 'warning'
    | 'error'
    | 'dark';
  name: string | React.ReactNode;
  active?: string;
  nested?: boolean;
  children?: React.ReactNode;
  open?: boolean;
  icon?: React.ReactNode;
  [key: string]: any;
}

function SidenavItem({
  color = 'info',
  name,
  active = '',
  children = false,
  open = false,
  icon,
  ...rest
}: SidenavItemProps) {
  const [controller] = useMaterialUIController();
  const theme = useTheme<FFTheme>();
  const { miniSidenav, transparentSidenav, whiteSidenav, darkMode } =
    controller;

  return (
    <>
      <ListItem
        {...rest}
        component="li"
        sx={item(theme, {
          active,
          color,
          transparentSidenav,
          whiteSidenav,
          darkMode,
        })}
      >
        <ListItemIcon
          sx={collapseIconBox(theme, {
            transparentSidenav,
            whiteSidenav,
            darkMode,
            active: Boolean(active),
          })}
        >
          {icon}
        </ListItemIcon>
        <MDBox
          sx={itemContent(theme, {
            active,
            miniSidenav,
            name,
            open,
            transparentSidenav,
            whiteSidenav,
            darkMode,
            color,
          })}
          style={{ paddingLeft: 0 }}
        >
          {/* <ListItemText primary={name} /> */}
          {typeof name === 'string' ? (
            <MDTypography
              variant="caption"
              color={active ? 'white' : 'info'}
              fontWeight="light"
              sx={{
                opacity: open ? 1 : 0,
                // Steerage sidebar: slate links, the active one in indigo on
                // its light tint. The caption's own colours were chosen for
                // the template's solid black pill and vanish on the tint.
                ...(whiteSidenav && {
                  color: `${active && active !== 'isParent' ? sidebar.linkActiveColor : sidebar.linkColor} !important`,
                  fontSize: sidebar.fontSize,
                  fontWeight: active && active !== 'isParent' ? 500 : 400,
                }),
              }}
            >
              {name}
            </MDTypography>
          ) : (
            <MDBox
              sx={{
                opacity: miniSidenav ? 0 : 1,
                transition: 'opacity 0.2s',
                display: 'flex',
                alignItems: 'center',
              }}
            >
              {name}
            </MDBox>
          )}
          {children && (
            <Icon
              component="i"
              sx={itemArrow(theme, {
                open,
                miniSidenav,
                transparentSidenav,
                whiteSidenav,
                darkMode,
                active,
                color,
              })}
            >
              expand_less
            </Icon>
          )}
        </MDBox>
      </ListItem>
      {children && (
        <Collapse in={open} timeout="auto" unmountOnExit {...rest}>
          {children}
        </Collapse>
      )}
    </>
  );
}

export { SidenavItem };
